import { useRef, useState, useEffect } from "react";

export function useVisibleColumnCount() {
  const headerRef = useRef(null);
  const [visibleColumnCount, setVisibleColumnCount] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      const ths = headerRef.current.querySelectorAll("th");
      const visibleCols = Array.from(ths).filter(
        (th) => th.offsetParent !== null
      ).length;
      setVisibleColumnCount(visibleCols);
    }

    return () => {
      headerRef.current = null;
    };
  }, []);

  return { headerRef, visibleColumnCount };
}
